import { Auth, SSOState } from './state';
import {
	IS_AUTH, TOKEN, AUTH_USER, AUTH_ERROR, SSO_STATE_SIGNOUT, SSO_STATE_ERROR,
} from '../getterTypes';


export const getters = {
	[IS_AUTH](state: Auth) {
		return state.isAuth;
	},
	[AUTH_ERROR](state: Auth) {
		return {
			message: state.error.message,
			counter: state.error.counter,
		};
	},
	[TOKEN](state: Auth) {
		return state.token;
	},
	// TODO: Jmeno and Primeni are in store twice - in Auth and in LoggedUser.
	[AUTH_USER](state: any) {
		return `${state.loggedUser.Jmeno} ${state.loggedUser.Prijmeni}`;
	},
	[SSO_STATE_ERROR](state: Auth) {
		return state.ssoState === SSOState.CheckingError;
	},
	[SSO_STATE_SIGNOUT](state: Auth) {
		return state.ssoState === SSOState.Signout;
	},
};
